import React from "react";
import styled from "styled-components";

const FooterSection = styled.footer`
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  padding: 80px 5% 40px;
  font-family: "Open Sans", sans-serif;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 50px;
  margin-bottom: 60px;
  flex-wrap: wrap;
`;

const Col = styled.div`
  flex: 1;
  min-width: 220px;
`;

const ColTitle = styled.h4`
  font-size: 16px;
  color: #1a202c; /* Contrast improvement */
  margin-bottom: 25px;
  font-weight: 700;
`;

const BrandDesc = styled.p`
  color: #4a5568; /* Contrast improvement */
  font-size: 14px;
  line-height: 1.7;
  margin-top: 12px;
  font-weight: 500;
`;

const BrandTitle = styled.h3`
  color: #4a5568;
  font-size: 20px;
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
`;

const LinksList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const LinkItem = styled.li`
  margin-bottom: 14px;

  a {
    color: #25aae3;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
      color: #1c94c9;
    }
  }
`;

const TrustPilotBox = styled.a`
  display: block;
  border: 1px solid #e2e8f0;
  border-left: 3px solid #fa6582; /* Pink/red accent */
  padding: 18px 24px;
  border-radius: 4px;
  color: #1a202c;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s ease;
  background: #fbfdff;

  &:hover {
    border-color: #bee0f1;
    background: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
  }
`;

const BottomSection = styled.div`
  border-top: 1px solid #e2e8f0;
  padding-top: 30px;
  text-align: left;
  color: #718096; /* Better contrast */
  font-size: 13px;
  font-weight: 600;
`;

const Footer = () => {
  return (
    <FooterSection>
      <Container>
        <TopSection>
          <Col style={{ flex: 1.5 }}>
            <div
              style={{ borderLeft: "3px solid #25aae3", paddingLeft: "20px" }}
            >
              <BrandTitle>Gainsta.</BrandTitle>
              <BrandDesc>
                Intelligent automation for social media! Choose which package is
                best suited for you.
              </BrandDesc>
            </div>
          </Col>

          <Col>
            <ColTitle>Main Navigation</ColTitle>
            <LinksList>
              <LinkItem>
                <a href="#home">Home</a>
              </LinkItem>
              <LinkItem>
                <a href="#faq">FAQ</a>
              </LinkItem>
              <LinkItem>
                <a href="#capabilities">Capabilities</a>
              </LinkItem>
              <LinkItem>
                <a href="#pricing">Pricing</a>
              </LinkItem>
              <LinkItem>
                <a href="#contact">Contact</a>
              </LinkItem>
            </LinksList>
          </Col>

          <Col>
            <ColTitle>Additional Links</ColTitle>
            <LinksList>
              <LinkItem>
                <a href="/shutdown">Login</a>
              </LinkItem>
              <LinkItem>
                <a href="/shutdown">Sign Up</a>
              </LinkItem>
            </LinksList>
          </Col>

          <Col>
            <ColTitle>See Our Trustpilot Ratings</ColTitle>
            <TrustPilotBox
              href="https://www.trustpilot.com/review/gainsta.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Trustpilot Rating
            </TrustPilotBox>
          </Col>
        </TopSection>

        <BottomSection>© 2022 Gainsta. All Rights Reserved.</BottomSection>
      </Container>
    </FooterSection>
  );
};

export default Footer;
